import { ReactNode, useState } from 'react';
import XLight from '@/assets/xLight.svg';
import Modal from '@/components/general/Modal';
import type { AnalyticsBuilderFieldSetType, AnalyticsBuilderTemplateType } from '@/types';
import AnalyticsBuilderList from './AnalyticsBuilderList';

type ReportGeneratorProps = {
  prompts: AnalyticsBuilderTemplateType[];
  fieldSets: AnalyticsBuilderFieldSetType[];
  children: (openPrompt: () => void) => ReactNode;
};

const ReportGenerator = ({ prompts, fieldSets, children }: ReportGeneratorProps) => {
  const [open, setOpen] = useState(false);

  const openPrompt = () => setOpen(true);

  return (
    <>
      {children(openPrompt)}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        contanerClassName="max-h-[92vh] w-full max-w-11/12 overflow-hidden bg-white shadow-2xl xl:max-w-[1400px]"
      >
        <div className="flex items-center justify-between border-b border-zinc-100 px-6 py-5">
          <div>
            <p className="text-xs font-semibold tracking-wide text-zinc-500 uppercase">Report Generator</p>
            <h2 className="text-xl font-semibold text-zinc-950">Choose your report</h2>
          </div>
          <button onClick={() => setOpen(false)} className="btn icon">
            <XLight className="h-7 w-7" />
          </button>
        </div>

        <div className="max-h-[calc(92vh-84px)] overflow-y-auto p-6" data-lenis-prevent>
          <AnalyticsBuilderList
            className="grid gap-4 md:grid-cols-2 xl:grid-cols-3"
            prompts={prompts}
            fieldSets={fieldSets}
          />
        </div>
      </Modal>
    </>
  );
};

export default ReportGenerator;
